"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialApiErrorRegistry = void 0;
/**
 * Per-endpoint error registry — which `FinancialErrorCodes` (plus the
 * generic cross-cutting `VALIDATION_ERROR` every endpoint can return)
 * a specific endpoint can actually respond with. Same pattern
 * `patient-error-registry.ts`/`appointment-error-registry.ts` already
 * established. This is what a `FinancialOpenApiOperations` entry's
 * `errorCodes` is built from (`../openapi`).
 */
const financial_error_codes_1 = require("./financial-error-codes");
const GENERIC_CODES = [financial_error_codes_1.FinancialErrorCodes.VALIDATION_ERROR];
function toContract(code) {
    return { code, ...(0, financial_error_codes_1.getFinancialErrorCatalogEntry)(code) };
}
function endpoint(name, codes) {
    return { endpoint: name, errors: [...codes, ...GENERIC_CODES].map(toContract) };
}
exports.FinancialApiErrorRegistry = {
    createPayment: endpoint('createPayment', [financial_error_codes_1.FinancialErrorCodes.PAYMENT_SPLIT_SUM_MISMATCH]),
    issueReceipt: endpoint('issueReceipt', [financial_error_codes_1.FinancialErrorCodes.PAYMENT_NOT_COMPLETED]),
    cancelReceipt: endpoint('cancelReceipt', [
        financial_error_codes_1.FinancialErrorCodes.RECEIPT_ALREADY_CANCELLED,
        financial_error_codes_1.FinancialErrorCodes.RECEIPT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    creditAdvanceDeposit: endpoint('creditAdvanceDeposit', [
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_ACCOUNT_NOT_ACTIVE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    debitAdvanceDeposit: endpoint('debitAdvanceDeposit', [
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_INSUFFICIENT_BALANCE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_ACCOUNT_NOT_ACTIVE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    settleDeposit: endpoint('settleDeposit', [
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_SETTLEMENT_NOT_APPLICABLE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_ACCOUNT_NOT_ACTIVE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    processRefund: endpoint('processRefund', [
        financial_error_codes_1.FinancialErrorCodes.RECEIPT_ALREADY_REFUNDED,
        financial_error_codes_1.FinancialErrorCodes.REFUND_ORIGINAL_PAYMENT_NOT_COMPLETED,
        financial_error_codes_1.FinancialErrorCodes.REFUND_EXCEEDS_ORIGINAL_PAYMENT,
    ]),
    activateTariff: endpoint('activateTariff', [
        financial_error_codes_1.FinancialErrorCodes.TARIFF_NOT_DRAFT,
        financial_error_codes_1.FinancialErrorCodes.TARIFF_HAS_NO_LINES,
        financial_error_codes_1.FinancialErrorCodes.TARIFF_OVERLAPPING_ACTIVE_WINDOW,
    ]),
    activatePackage: endpoint('activatePackage', [
        financial_error_codes_1.FinancialErrorCodes.PACKAGE_NOT_DRAFT,
        financial_error_codes_1.FinancialErrorCodes.PACKAGE_HAS_NO_INCLUDED_ITEMS,
    ]),
    applyDiscount: endpoint('applyDiscount', [
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_RULE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_RULE_NOT_EFFECTIVE,
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_REDEMPTION_LIMIT_REACHED,
    ]),
    recordPostingEvent: endpoint('recordPostingEvent', []),
    resolveApprovalChain: endpoint('resolveApprovalChain', []),
    computeChargeBilling: endpoint('computeChargeBilling', [
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_NOT_IN_TARIFF,
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_RULE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_RULE_NOT_EFFECTIVE,
        financial_error_codes_1.FinancialErrorCodes.DISCOUNT_REDEMPTION_LIMIT_REACHED,
    ]),
    billAgainstAdvance: endpoint('billAgainstAdvance', [
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_NOT_IN_TARIFF,
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_INSUFFICIENT_BALANCE,
        financial_error_codes_1.FinancialErrorCodes.ADVANCE_DEPOSIT_ACCOUNT_NOT_ACTIVE,
    ]),
    billAndCreatePayment: endpoint('billAndCreatePayment', [
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_NOT_IN_TARIFF,
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.PAYMENT_SPLIT_SUM_MISMATCH,
    ]),
    processCorporateBilling: endpoint('processCorporateBilling', [
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_NOT_IN_TARIFF,
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.PAYMENT_SPLIT_SUM_MISMATCH,
    ]),
    processInsuranceBilling: endpoint('processInsuranceBilling', [
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_NOT_IN_TARIFF,
        financial_error_codes_1.FinancialErrorCodes.BILLING_CHARGE_INACTIVE,
        financial_error_codes_1.FinancialErrorCodes.PAYMENT_SPLIT_SUM_MISMATCH,
    ]),
};
//# sourceMappingURL=financial-error-registry.js.map